import { getRoadsideProducts } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { Product } from '@/interfaces/entities/product.interface';

export const BuyRoadsideService = {
  async getRoadsideProducts(validFor: string = 'Person'): Promise<Product[] | null> {
    try {
      return await _http.HttpGet(getRoadsideProducts.replace('{0}', validFor));
    } catch (error) {
      console.error('Failed to load roadside products');
      return null;
    }
  },
} as const;
